import React, { useState } from 'react'

import { IMenuItem } from '..'

import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip'
import DirectionsCarFilledOutlinedIcon from '@mui/icons-material/DirectionsCarFilledOutlined'
import SellOutlinedIcon from '@mui/icons-material/SellOutlined'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import MiscellaneousServicesOutlinedIcon from '@mui/icons-material/MiscellaneousServicesOutlined'
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar'
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined'
import BoltIcon from '@mui/icons-material/Bolt'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AnalyticsIcon from '@mui/icons-material/Analytics'
import SyncAltIcon from '@mui/icons-material/SyncAlt'

import { useMenu } from '@/hooks/useMenu'
import { Link } from 'react-router-dom'
import CustomView from '@/components/CustomView'
import styled from 'styled-components'
import CustomGraphy from '@/components/CustomGraphy'
import { addLeadingSlash } from '@/utils/helpers'

const SubCategory = styled(CustomView)<{ color: string; back: string }>`
  color: ${(props) => props.color};
  background-color: ${(props) => props.back};
  font-size: 14px;
  padding-top: 12px;
  padding-bottom: 12px;
  &:hover {
    background-color: #f3f4f6;
    color: #142954;
  }
`

function getIcon(icon: string) {
  switch (icon) {
    case 'Dashboard':
      return (
        <DashboardOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'analises-gerenciais':
      return (
        <AnalyticsIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'Car':
      return (
        <DirectionsCarFilledOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'Price_Tag':
      return (
        <SellOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'Refund':
      return (
        <LocalAtmIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'Repair':
      return (
        <BuildOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'cogs':
      return (
        <MiscellaneousServicesOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'user':
      return (
        <PermIdentityOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'ArrowClose':
      return (
        <CloseFullscreenIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'privacity':
      return (
        <PrivacyTipIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'perfil':
      return (
        <PermContactCalendarIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'ativo':
      return (
        <LocationOnIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'files':
      return (
        <FolderOutlinedIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    case 'sync':
      return (
        <SyncAltIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
    default:
      return (
        <BoltIcon
          className="icon-img"
          style={{ fontSize: '18px', color: 'gray' }}
        />
      )
  }
}

export function Item({ icon, title, subcategory, active }: IMenuItem) {
  const { toggle } = useMenu()
  const [subCategoryIsOpen, setSubCategoryIsOpen] = useState(false)

  function openSubcategory() {
    if (subcategory && subcategory.length >= 1) {
      setSubCategoryIsOpen(!subCategoryIsOpen)
    }
  }

  function setOnSessionStorage(path: string) {
    sessionStorage.setItem('subcategory-path', path)
  }

  return (
    <CustomView
      onClick={
        subcategory && subcategory.length >= 1 ? openSubcategory : () => {}
      }
    >
      <CustomView
        height={50}
        py="xs"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
        className="background-hover"
      >
        <CustomView
          flexGrow={toggle ? 'initial' : 1}
          margin={toggle ? 'auto' : ''}
          width="unset"
          alignItems="center"
          className="anchor--hover"
          flexDirection="row"
        >
          <CustomView
            flexDirection="row"
            width="unset"
            mr={toggle ? '' : '16px'}
            ml={toggle ? '' : '24px'}
            m={toggle ? '0 auto' : ''}
          >
            {getIcon(icon)}
          </CustomView>
          <CustomGraphy>{title}</CustomGraphy>
        </CustomView>
      </CustomView>
      {subcategory &&
        subcategory.length >= 1 &&
        (subCategoryIsOpen || active) &&
        !toggle && (
          <CustomView backColor="violet">
            {subcategory.map((item, key) => (
              <Link
                key={key}
                style={{ textDecoration: 'none', color: 'unset' }}
                to={addLeadingSlash(item.redirect)}
                onClick={() => setOnSessionStorage(item.redirect)}
              >
                <SubCategory
                  back={
                    sessionStorage.getItem('subcategory-path') === item.redirect
                      ? '#e7eaee'
                      : '#f3f4f6'
                  }
                  color={
                    sessionStorage.getItem('subcategory-path') === item.redirect
                      ? '#142954'
                      : '#8f98ad'
                  }
                  pl="62px"
                >
                  {item.title}
                </SubCategory>
              </Link>
            ))}
          </CustomView>
        )}
    </CustomView>
  )
}
